import { QRCodeCanvas } from "qrcode.react";
import { useNavigate } from "react-router-dom";
import "./Setup2FA.css";

export default function Setup2FA() {
  const navigate = useNavigate();

  const qrCode = localStorage.getItem("qrCode");
  const manualKey = localStorage.getItem("manualKey");

  if (!qrCode) {
    return (
      <div className="setup2fa-page">
        <div className="setup2fa-content">
          <div className="setup2fa-card">No QR code found</div>
        </div>
      </div>
    );
  }

  return (
    <div className="setup2fa-page">
      <div className="setup2fa-content">
        <div className="setup2fa-logo-section">
          <img loading="lazy"
            src={require("../assest/logo.png")}
            alt="Univision Logo"
            className="setup2fa-logo-img"
          />
        </div>
        <div className="setup2fa-card">
          <h2 className="setup2fa-title">Set up Google Authenticator</h2>
          <p className="setup2fa-subtitle">
            Scan this QR code using Google Authenticator
          </p>
          <div className="setup2fa-qr-wrapper">
            <QRCodeCanvas value={qrCode} size={200} />
          </div>
          <p className="setup2fa-manual-key">
            Manual key (backup):<br />
            <strong>{manualKey}</strong>
          </p>
          <button
            className="setup2fa-continue-btn"
            onClick={() => navigate("/otp")}
          >
            I've scanned → Continue
          </button>
        </div>
      </div>
    </div>
  );
}
